import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './index.less';

const cx = classNames.bind(styles);

interface Props {
  level?: number;
  id?: string;
  text?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Heading = ({ level = 2, id = '', text = '', className = '', ...props }: Props) => {
  const headingRef = useRef(null);

  // 如果没有提供id，则根据内容生成一个
  useEffect(() => {
    if (!id && headingRef.current) {
      // 生成id：移除空格和特殊字符，转换为小写
      const generatedId = text?.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      headingRef.current.id = generatedId;
    }
  }, [id, text]);

  return (
    <div
      ref={headingRef}
      id={id}
      role="heading"
      aria-level={level}
      className={cx('heading', `heading-level-${level}`, className)}
      {...props}
    >
      {text}
    </div>
  );
};
export default Heading;